import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { Button } from 'reactstrap';

function NotificationLatest(props) {
    const reloadBuild = () => {
        // Reload the page
        window.location.reload();
    }

    const dismissBuildNotification = () => {
        // Dismiss the notification
        localStorage.setItem('linguise:silentNotification', new Date());

        props && props.onDismiss && props.onDismiss();
    }

    return (
        <div className="linguise-outdated-notification">
            <div className="header-title">New dashboard version available!</div>
            <p>Click here to update.</p>
            <div className="d-flex flex-row btn-row">
                <Button color="primary" onClick={reloadBuild}>Reload</Button>
                <Button color="secondary" onClick={dismissBuildNotification}>Dismiss</Button>
            </div>  
        </div>
    )
}

function NotificationBuild() {
    const [isOutdated, setIsOutdated] = useState(false);

    // Dismiss will work for 5 minutes
    const isDismissed = () => {
        const silentNotification = localStorage.getItem('linguise:silentNotification');
        if (silentNotification) {
            const now = new Date();
            const diff = now - new Date(silentNotification);
            return diff < 5 * 60 * 1000;
        }
        return false;
    }

    const onDismiss = () => {
        setIsOutdated(false);

        setTimeout(() => {
            localStorage.removeItem('linguise:silentNotification');
            reloadMetaJson();
        }, ((10 * 60) + 5) * 1000); // 10 minutes + 5 seconds
    }

    const reloadMetaJson = () => {
        const currentTime = Math.floor(new Date().getTime() / 1000);

        fetch(`/meta.json?t=${currentTime}`)
            .then((response) => response.json())
            .then((meta) => {
                const remoteBuild = meta.version;
                // eslint-disable-next-line no-undef
                const currentBuild = GLOBAL_LINGUISE_VERSION;

                if (currentBuild !== remoteBuild && !isDismissed()) {
                    setIsOutdated(true);
                } else {
                    setIsOutdated(false);
                }
            }).catch((error) => {/* silently ignore */});
    }

    useEffect(() => {
        reloadMetaJson();

        // Check every 2 minutes
        const interval = setInterval(() => {
            reloadMetaJson();
        }, 2 * 60 * 1000);

        return () => {
            clearInterval(interval);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {isOutdated && createPortal(
                <NotificationLatest onDismiss={onDismiss} />,
                document.body,
            )}
        </>
    )
}

export default NotificationBuild;